import {Swiper, FreeMode} from "swiper";
import {breakpoint} from "../utils/breakpoints";
import {loadElementLazyImage} from "../helpers/lazy-load";
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import {breakpointDown} from "../helpers/breakpoints";

gsap.registerPlugin(ScrollTrigger)


$('.js-header-page-select-slider').each(function (i, el) {

  let sliderWidth = $(el).width()
  let sliderElementsWidth = 0
  let initialSlide = 0;

  $(el).find('.swiper-slide').each(function(i, el){
    sliderElementsWidth = sliderElementsWidth + $(this).width()
    if ($(this).find('.page-button').hasClass('active')) initialSlide = i;
  })

  if (sliderElementsWidth >= sliderWidth) {
    let swiper = new Swiper(el, {
      modules: [FreeMode],
      slidesPerView: "auto",
      centeredSlides: false,
      freeMode: true,
      initialSlide: initialSlide,
      breakpoints: {
        744: {
          //centeredSlides: true,
        },
      }
    })
  }


  // sticky page select
  if ($(window).width() <= breakpoint('lg')) {
    let pageSelect = $('.js-header-page-select-slider')

    ScrollTrigger.create({
      trigger: pageSelect,
      start: "top-=8 top", // el top, screen top
      once: false,
      onEnter: () => {
        pageSelect.addClass('fixed')
      },
      onLeaveBack: () => {
        pageSelect.removeClass('fixed')
      }
    });


  }



    if (breakpointDown('xl')) {
      // animate  when in screen
      let swiperLastEl = $(el).find('.swiper-slide').last()
      if (swiperLastEl.offset().left + swiperLastEl.width() > window.innerWidth - 20) {

        let swiper = new Swiper(el, {
          slidesPerView: 'auto',
        });

        ScrollTrigger.create({
          trigger: el,
          start: "top bottom", // el top, screen bottom
          once: true,
          onEnter: () => {
            $(el).find('.swiper-wrapper').delay(400).animate({ left: '-80px' }, 600,
              function () {
                $(this).animate({ left: 0 }, 600)
              })
          }
        });

      }
    }



})

